import { render, staticRenderFns } from "./FormSchemaInputs.vue?vue&type=template&id=b0ebcf9a&"
import script from "./FormSchemaInputs.vue?vue&type=script&lang=js&"
export * from "./FormSchemaInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports